
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexKtDz0_7_45QLag9vjAenei_45PKk9I1NFjG2HHvwgbeUWKQMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/index.vue?macro=true";
import { default as _91_46_46_46404_93ou8GAdJ_45HP_45MoJK_y83moViPg5xTqyJ9oVHNeV5qVIQMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/[...404].vue?macro=true";
import { default as registerPdRoiSrOeRHwuUBbRXhZNhxordn_452uhs1dpofPkgvGwMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/register.vue?macro=true";
import { default as teamJjyidpFBA38V_45e76jSKhuC5H5B6pwApEL2dhyXd4cRkMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/vdp/team.vue?macro=true";
import { default as logino8DpOGnjwtezLhEOK75ketqa4hlTzri_45nuBkqI0anrgMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/vdp/login.vue?macro=true";
import { default as vdpN0hZSB5eVn2aG_456Z9oYKtXpheX_oKPW7MGxJ7h_45XRlsMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/public/vdp.vue?macro=true";
import { default as _91id_93C4ZfPt2X6rY58Jmq9OC0Au95bTEwLKyVgEUZGJ3CykMMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/public/[id].vue?macro=true";
import { default as detailsjmQCyDFemn4HGP0ZTfn2Mswqrn7CR7OxAdTIhPsbkXwMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/vdp/ai/[id]/details.vue?macro=true";
import { default as _91id_93V7P9vQZ277qx46v8NRpEj9MxXI7gqchC5Jly3se8nkoMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/vdp/ai/[id].vue?macro=true";
import { default as scanid4mkLHvaeCC16Uti8D37i8y7Q4KNf_45yJzK_aqox0DUMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/vdp/ai/scan.vue?macro=true";
import { default as upgradeA5JtsCgc9JLshh8AtK_ozcO45CG5btHBDTC5eCWbh5oMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/vdp/upgrade.vue?macro=true";
import { default as settings2qgax__45hoKYdoXLPEANJJM7rGdsT6OvkHGzymvz_454HgMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/vdp/settings.vue?macro=true";
import { default as vendor7rkKtVupnB9ANWIXmWFrWWVvuz_45Fvep0cNJFOCCoapMMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/iframe/vendor.vue?macro=true";
import { default as _91slug_93w12MbPL6770sUhfABGC2_45z_NLT9pxwzor2BLyin8lNMMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/public/[slug].vue?macro=true";
import { default as loginHK_bQ_45Pf_450n2j_45Gzdp5ij7qlaGr6NBUNBt00ne5r8ocMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/researchers/login.vue?macro=true";
import { default as access_45denied5w987XKlXTUyyW2rnDTkqPa4SbLA7mRmxFKiN5BNEAEMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/vdp/access-denied.vue?macro=true";
import { default as fixedmWbJU3jhKm41k1LPumWIkXFZ97Z2athhAmx2tz4M9hoMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/vdp/reports/fixed.vue?macro=true";
import { default as start_45programJOEeMfG8ODOIx2RLr7eSb1Bb9ruTYW0iHCc81uzrOV0Meta } from "/codebuild/output/src3966139036/src/portals-fe/pages/vdp/start-program.vue?macro=true";
import { default as createVm9zIXI09TjbpfGlK7z_45u7Mb3IvBI_PnHx8QwsxvtScMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/researchers/create.vue?macro=true";
import { default as create_45account3RBz03qdu81zN_455krK2A2QxSftoHmqX1_45tSqMjZOyYIMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/vdp/create-account.vue?macro=true";
import { default as indexMsEg_eR__OrNlRZB9RUH39uO6F9ze6209mx_45dJ_hYXoMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/vdp/programs/index.vue?macro=true";
import { default as create_45reportVCAAB9_452oNXL8vDlY3hyA597Jy8hLIu27izH5svWutsMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/public/create-report.vue?macro=true";
import { default as settingsv476GocbagLHNwlUSPCOgL1_45BLbKMjXX3yLrVjDVCzUMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/researchers/settings.vue?macro=true";
import { default as editr1qgNZtkOU4yaHcREBO57E4O57ehLCSJEmEG1g6lLiYMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/vdp/programs/[id]/edit.vue?macro=true";
import { default as _91uuid_93MWkjJK2myOjlaEY1Zs_hv_UEtmByvwczZmOqCmqdmI8Meta } from "/codebuild/output/src3966139036/src/portals-fe/pages/login/magic-link/[uuid].vue?macro=true";
import { default as indexvJjrfFgyCACw1yzuwJ1RcqcsBmGmebGwgWWZEdVJxW4Meta } from "/codebuild/output/src3966139036/src/portals-fe/pages/vdp/programs/[id]/index.vue?macro=true";
import { default as fix_pendinglIEmUg3TM5I5vzqdFBrmTOCPhSMsQPzVo_KHwoQNhw8Meta } from "/codebuild/output/src3966139036/src/portals-fe/pages/vdp/reports/fix_pending.vue?macro=true";
import { default as indexrU_45CsxOhB_lEzvXIWB_GKxXOel8FE6_pA0E5QT9YBqkMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/researchers/[uuid]/index.vue?macro=true";
import { default as indexymy6iw7J35gTxuaJnPxXiaw2riqrGlDOQ_45lVLG1mjEAMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/vdp/ai/code-review/index.vue?macro=true";
import { default as awaiting_fixV2HepS7hgIU0_Ly_vJw_KOcoErwULfuTrB1OiWBC66kMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/vdp/reports/awaiting_fix.vue?macro=true";
import { default as index4bYsYMrewib6Tqfrsn8tHxErGiALcCrTdH6AbfTzw2UMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/vdp/ai/code-review/[id]/index.vue?macro=true";
import { default as previewtAQm3xQqPQ6xEN46WBow24CafaneXltFpimXh8vUGMMMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/researchers/reports/[id]/preview.vue?macro=true";
import { default as previewjiAILDjkAclnXm8nSH_45CpzFjCrGvXpMwteGHXL2QaAwMeta } from "/codebuild/output/src3966139036/src/portals-fe/pages/vdp/vulnerabilities/[id]/preview.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexKtDz0_7_45QLag9vjAenei_45PKk9I1NFjG2HHvwgbeUWKQMeta || {},
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/index.vue")
  },
  {
    name: "404",
    path: "/:404(.*)*",
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/[...404].vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerPdRoiSrOeRHwuUBbRXhZNhxordn_452uhs1dpofPkgvGwMeta || {},
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/register.vue")
  },
  {
    name: "vdp-team",
    path: "/vdp/team",
    meta: { ...(teamJjyidpFBA38V_45e76jSKhuC5H5B6pwApEL2dhyXd4cRkMeta || {}), ...{"middleware":["auth-vendor","capability","user-role"]} },
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/vdp/team.vue")
  },
  {
    name: "vdp-login",
    path: "/vdp/login",
    meta: { ...(logino8DpOGnjwtezLhEOK75ketqa4hlTzri_45nuBkqI0anrgMeta || {}), ...{"middleware":["guest-vendor"]} },
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/vdp/login.vue")
  },
  {
    name: "public-vdp",
    path: "/public/vdp",
    meta: vdpN0hZSB5eVn2aG_456Z9oYKtXpheX_oKPW7MGxJ7h_45XRlsMeta || {},
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/public/vdp.vue")
  },
  {
    name: "public-id",
    path: "/public/:id()",
    meta: _91id_93C4ZfPt2X6rY58Jmq9OC0Au95bTEwLKyVgEUZGJ3CykMMeta || {},
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/public/[id].vue")
  },
  {
    name: "vdp-ai-id",
    path: "/vdp/ai/:id()",
    meta: { ...(_91id_93V7P9vQZ277qx46v8NRpEj9MxXI7gqchC5Jly3se8nkoMeta || {}), ...{"middleware":["auth-vendor","capability","user-role"]} },
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/vdp/ai/[id].vue"),
    children: [
  {
    name: "vdp-ai-id-details",
    path: "details",
    meta: { ...(detailsjmQCyDFemn4HGP0ZTfn2Mswqrn7CR7OxAdTIhPsbkXwMeta || {}), ...{"middleware":["auth-vendor","capability","user-role"]} },
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/vdp/ai/[id]/details.vue")
  }
]
  },
  {
    name: "vdp-ai-scan",
    path: "/vdp/ai/scan",
    meta: { ...(scanid4mkLHvaeCC16Uti8D37i8y7Q4KNf_45yJzK_aqox0DUMeta || {}), ...{"middleware":["auth-vendor","capability","user-role"]} },
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/vdp/ai/scan.vue")
  },
  {
    name: "vdp-upgrade",
    path: "/vdp/upgrade",
    meta: { ...(upgradeA5JtsCgc9JLshh8AtK_ozcO45CG5btHBDTC5eCWbh5oMeta || {}), ...{"middleware":["auth-vendor","user-role"]} },
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/vdp/upgrade.vue")
  },
  {
    name: "vdp-settings",
    path: "/vdp/settings",
    meta: { ...(settings2qgax__45hoKYdoXLPEANJJM7rGdsT6OvkHGzymvz_454HgMeta || {}), ...{"middleware":["auth-vendor"]} },
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/vdp/settings.vue")
  },
  {
    name: "iframe-vendor",
    path: "/iframe/vendor",
    meta: vendor7rkKtVupnB9ANWIXmWFrWWVvuz_45Fvep0cNJFOCCoapMMeta || {},
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/iframe/vendor.vue")
  },
  {
    name: "public-slug",
    path: "/public/:slug()",
    meta: _91slug_93w12MbPL6770sUhfABGC2_45z_NLT9pxwzor2BLyin8lNMMeta || {},
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/public/[slug].vue")
  },
  {
    name: "researchers-login",
    path: "/researchers/login",
    meta: { ...(loginHK_bQ_45Pf_450n2j_45Gzdp5ij7qlaGr6NBUNBt00ne5r8ocMeta || {}), ...{"middleware":["guest-researcher"]} },
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/researchers/login.vue")
  },
  {
    name: "vdp-access-denied",
    path: "/vdp/access-denied",
    meta: access_45denied5w987XKlXTUyyW2rnDTkqPa4SbLA7mRmxFKiN5BNEAEMeta || {},
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/vdp/access-denied.vue")
  },
  {
    name: "vdp-reports-fixed",
    path: "/vdp/reports/fixed",
    meta: { ...(fixedmWbJU3jhKm41k1LPumWIkXFZ97Z2athhAmx2tz4M9hoMeta || {}), ...{"middleware":["auth-vendor"]} },
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/vdp/reports/fixed.vue")
  },
  {
    name: "vdp-start-program",
    path: "/vdp/start-program",
    meta: { ...(start_45programJOEeMfG8ODOIx2RLr7eSb1Bb9ruTYW0iHCc81uzrOV0Meta || {}), ...{"middleware":["auth-vendor"]} },
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/vdp/start-program.vue")
  },
  {
    name: "researchers-create",
    path: "/researchers/create",
    meta: { ...(createVm9zIXI09TjbpfGlK7z_45u7Mb3IvBI_PnHx8QwsxvtScMeta || {}), ...{"middleware":["auth-researcher"]} },
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/researchers/create.vue")
  },
  {
    name: "vdp-create-account",
    path: "/vdp/create-account",
    meta: { ...(create_45account3RBz03qdu81zN_455krK2A2QxSftoHmqX1_45tSqMjZOyYIMeta || {}), ...{"middleware":["auth-vendor","is-vendor-active"]} },
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/vdp/create-account.vue")
  },
  {
    name: "vdp-programs",
    path: "/vdp/programs",
    meta: { ...(indexMsEg_eR__OrNlRZB9RUH39uO6F9ze6209mx_45dJ_hYXoMeta || {}), ...{"middleware":["auth-vendor"]} },
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/vdp/programs/index.vue")
  },
  {
    name: "public-create-report",
    path: "/public/create-report",
    meta: create_45reportVCAAB9_452oNXL8vDlY3hyA597Jy8hLIu27izH5svWutsMeta || {},
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/public/create-report.vue")
  },
  {
    name: "researchers-settings",
    path: "/researchers/settings",
    meta: { ...(settingsv476GocbagLHNwlUSPCOgL1_45BLbKMjXX3yLrVjDVCzUMeta || {}), ...{"middleware":["auth-researcher"]} },
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/researchers/settings.vue")
  },
  {
    name: "vdp-programs-id-edit",
    path: "/vdp/programs/:id()/edit",
    meta: { ...(editr1qgNZtkOU4yaHcREBO57E4O57ehLCSJEmEG1g6lLiYMeta || {}), ...{"middleware":["auth-vendor"]} },
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/vdp/programs/[id]/edit.vue")
  },
  {
    name: "login-magic-link-uuid",
    path: "/login/magic-link/:uuid()",
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/login/magic-link/[uuid].vue")
  },
  {
    name: "vdp-programs-id",
    path: "/vdp/programs/:id()",
    meta: { ...(indexvJjrfFgyCACw1yzuwJ1RcqcsBmGmebGwgWWZEdVJxW4Meta || {}), ...{"middleware":["auth-vendor"]} },
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/vdp/programs/[id]/index.vue")
  },
  {
    name: "vdp-reports-fix_pending",
    path: "/vdp/reports/fix_pending",
    meta: { ...(fix_pendinglIEmUg3TM5I5vzqdFBrmTOCPhSMsQPzVo_KHwoQNhw8Meta || {}), ...{"middleware":["auth-vendor"]} },
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/vdp/reports/fix_pending.vue")
  },
  {
    name: "researchers-uuid",
    path: "/researchers/:uuid()",
    meta: { ...(indexrU_45CsxOhB_lEzvXIWB_GKxXOel8FE6_pA0E5QT9YBqkMeta || {}), ...{"middleware":["auth-researcher"]} },
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/researchers/[uuid]/index.vue")
  },
  {
    name: "vdp-ai-code-review",
    path: "/vdp/ai/code-review",
    meta: indexymy6iw7J35gTxuaJnPxXiaw2riqrGlDOQ_45lVLG1mjEAMeta || {},
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/vdp/ai/code-review/index.vue")
  },
  {
    name: "vdp-reports-awaiting_fix",
    path: "/vdp/reports/awaiting_fix",
    meta: { ...(awaiting_fixV2HepS7hgIU0_Ly_vJw_KOcoErwULfuTrB1OiWBC66kMeta || {}), ...{"middleware":["auth-vendor"]} },
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/vdp/reports/awaiting_fix.vue")
  },
  {
    name: "vdp-ai-code-review-id",
    path: "/vdp/ai/code-review/:id()",
    meta: index4bYsYMrewib6Tqfrsn8tHxErGiALcCrTdH6AbfTzw2UMeta || {},
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/vdp/ai/code-review/[id]/index.vue")
  },
  {
    name: "researchers-reports-id-preview",
    path: "/researchers/reports/:id()/preview",
    meta: { ...(previewtAQm3xQqPQ6xEN46WBow24CafaneXltFpimXh8vUGMMMeta || {}), ...{"middleware":["check-token-researcher"]} },
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/researchers/reports/[id]/preview.vue")
  },
  {
    name: "vdp-vulnerabilities-id-preview",
    path: "/vdp/vulnerabilities/:id()/preview",
    meta: { ...(previewjiAILDjkAclnXm8nSH_45CpzFjCrGvXpMwteGHXL2QaAwMeta || {}), ...{"middleware":["check-token-vendor"]} },
    component: () => import("/codebuild/output/src3966139036/src/portals-fe/pages/vdp/vulnerabilities/[id]/preview.vue")
  }
]